import { localizedFormat, localizedFormatter } from './localizedFormatter';

export const getMinuteFormat = localizedFormat(/m{1,2}/, true);
export default localizedFormatter(getMinuteFormat);
